/**
 * Serviço de Chat e Consultas à IA
 * Gerencia comunicação com a Aline (assistente fiscal)
 */

import api from './api';

const chatService = {
  /**
   * Envia mensagem para a Aline (chat completo)
   */
  sendMessage: async (message, conversationHistory = []) => {
    try {
      console.log('💬 [ChatService] Enviando mensagem:', message);
      const response = await api.post('/chat/message', {
        message,
        conversationHistory
      });
      console.log('✅ [ChatService] Resposta recebida');
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao enviar mensagem:', error);
      throw error;
    }
  },

  /**
   * Consulta específica sobre dedutibilidade de despesa
   */
  consultarDedutibilidade: async (despesa) => {
    try {
      console.log('🔍 [ChatService] Consultando dedutibilidade:', despesa);
      const response = await api.post('/chat/consultar-dedutibilidade', {
        despesa
      });
      console.log('✅ [ChatService] Análise fiscal recebida');
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao consultar dedutibilidade:', error);
      throw error;
    }
  },

  /**
   * Marca usuário como não sendo mais primeiro acesso
   */
  /**
   * Busca insight proativo da Aline com base nos dados financeiros reais
   */
  getInsights: async () => {
    try {
      const response = await api.get('/chat/insights');
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao buscar insights:', error);
      return null;
    }
  },

  markNotFirstAccess: async () => {
    try {
      console.log('✅ [ChatService] Marcando não primeiro acesso');
      const response = await api.post('/chat/mark-not-first-access');
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao marcar primeiro acesso:', error);
      throw error;
    }
  }
};

export default chatService;
